module.exports = __webpack_public_path__ + "static/media/swipeLeft.e9c29b90.png";